<template>
  <div class="row">
    <Station :stationData="data.stationData" :locale="locale" />
    <div class="tf-station-foo">
								Station
		</div>
  </div>
</template>

<script>
// components
import Station from "@/vue/station-domain/components/station.vue";


// Composables
import useLocale from "@/vue/composables/useLocale";

const locale = useLocale();

export default {
  name: "StationApp",
  components: {
    Station,
  },

  data() {
    return {
      locale: useLocale(),
      stationId: window.lihe.stationId,
      data: {
        stationData: null,
      },
    };
  },

  methods: {
    async loadSationData() {
      try {
        const requestData = {
          locale: this.locale === "fr_FR_CSE" ? "fr_FR" : this.locale,
          stationId: this.stationId,
        };

        const res = await window.catalogService.getStationData(requestData);
        this.data.stationData= res;
      } catch (error) {
        console.error("Failed to fetch content for station-domain app:", error);
      }
    },
  },

  async mounted() {
    //call api station data
    await this.loadSationData();
  },
};
</script>

<style scoped>
.tf-station-foo {
  display: none;
}
</style>
